<template>
  <div class="mr-8 px-4 sm:px-6 lg:px-8">
    <div dir="rtl" class="mt-8 flex flex-col">
      <div class="sm:flex-auto">
        <h1 class="text-lg font-medium text-gray-900">إضافة دارس</h1>
        <p class="mt-2 text-xs text-gray-700">نفس بيانات التسجيل في التطبيق</p>
      </div>

      <div v-if="successMessage" class="mt-4 rounded-md bg-green-50 p-4 text-green-800 border border-green-200">
        {{ successMessage }}
      </div>
      <div v-if="errorMessage" class="mt-4 rounded-md bg-red-50 p-4 text-red-800 border border-red-200">
        {{ errorMessage }}
      </div>

      <div class="mt-5 md:mt-0">
        <form @submit.prevent="submit" ref="addStudent">
          <div class="shadow overflow-hidden sm:rounded-md">
            <div class="px-4 py-5 bg-white sm:p-6">
              <div class="grid grid-cols-6 gap-6">
                <!-- Tenant (only shown when user can choose) -->
                <div v-if="showTenantSelector" class="col-span-6 sm:col-span-3">
                  <label class="block text-sm font-medium text-gray-700">الفرع</label>
                  <select
                    v-model="tenantId"
                    class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm pr-7"
                    required
                  >
                    <option disabled value="">اختر الفرع</option>
                    <option v-for="t in tenants" :key="t.id" :value="t.id">
                      {{ t.name || t.code || t.id }}
                    </option>
                  </select>
                  <p class="mt-1 text-xs text-gray-500">لـ GENERAL_MANAGER فقط</p>
                </div>

                <div class="col-span-6 sm:col-span-3">
                  <label class="block text-sm font-medium text-gray-700">الاسم الكامل</label>
                  <input
                    type="text"
                    v-model="fullName"
                    class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                    required
                  />
                </div>

                <div class="col-span-6 sm:col-span-3">
                  <label class="block text-sm font-medium text-gray-700">البريد الإلكتروني</label>
                  <input
                    type="email"
                    v-model="email"
                    class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                    required
                    @input="validateEmail"
                  />
                  <span class="text-center text-red-500 text-xs" v-if="emailError">{{ emailError }}</span>
                </div>

                <div class="col-span-6 sm:col-span-3">
                  <label class="block text-sm font-medium text-gray-700">رقم الجوال</label>
                  <div class="mt-1 flex gap-2">
                    <input
                      type="text"
                      v-model="phoneCountryCode"
                      placeholder="+966"
                      class="w-24 focus:ring-blue-500 focus:border-blue-500 block shadow-sm sm:text-sm border-gray-300 rounded-md"
                    />
                    <input
                      type="text"
                      v-model="phone"
                      placeholder="5xxxxxxxx"
                      class="flex-1 focus:ring-blue-500 focus:border-blue-500 block shadow-sm sm:text-sm border-gray-300 rounded-md"
                      required
                    />
                  </div>
                </div>

                <div class="col-span-6 sm:col-span-3">
                  <label class="block text-sm font-medium text-gray-700">العمر</label>
                  <input
                    type="number"
                    v-model.number="age"
                    min="1"
                    max="120"
                    class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                    required
                  />
                </div>

                <div class="col-span-6 sm:col-span-3">
                  <label class="block text-sm font-medium text-gray-700">المؤهل</label>
                  <select
                    v-model="qualificationId"
                    class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm pr-7"
                    required
                  >
                    <option disabled value="">اختر المؤهل</option>
                    <option v-for="q in qualifications" :key="q.id" :value="q.id">
                      {{ q.qualificationValue || q.qualification_value || q.value || q.name || q.id }}
                    </option>
                  </select>
                </div>

                <div class="col-span-6 sm:col-span-3">
                  <label class="block text-sm font-medium text-gray-700">المدة</label>
                  <select
                    v-model="durationId"
                    class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm pr-7"
                    required
                  >
                    <option disabled value="">اختر المدة</option>
                    <option v-for="d in durations" :key="d.id" :value="d.id">
                      {{ d.durationDesc || d.duration_desc || d.value || d.name || d.id }}
                    </option>
                  </select>
                </div>

                <div class="col-span-6 sm:col-span-3">
                  <label class="block text-sm font-medium text-gray-700">المسار (اختياري)</label>
                  <select
                    v-model="masarratId"
                    class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm pr-7"
                  >
                    <option value="">بدون</option>
                    <option v-for="m in massarats" :key="m.id" :value="m.id">
                      {{ m.value || m.name || m.id }}
                    </option>
                  </select>
                </div>

                <div class="col-span-6 sm:col-span-3">
                  <label class="block text-sm font-medium text-gray-700">كلمة المرور</label>
                  <input
                    :type="showPassword ? 'text' : 'password'"
                    v-model="password"
                    class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                    required
                    @input="validatePassword"
                  />
                  <span v-if="passwordError" class="text-center text-red-500 text-xs">{{ passwordError }}</span>
                  <div class="block text-sm font-medium text-gray-700 mt-2 mr-2">
                    <input type="checkbox" v-model="showPassword" />
                    عرض كلمة المرور
                  </div>
                </div>

                <div class="col-span-6 sm:col-span-3">
                  <label class="block text-sm font-medium text-gray-700">تأكيد كلمة المرور</label>
                  <input
                    :type="showPassword ? 'text' : 'password'"
                    v-model="confirmPassword"
                    class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                    required
                    @input="validatePassword"
                  />
                  <span v-if="confirmPasswordError" class="text-center text-red-500 text-xs">{{ confirmPasswordError }}</span>
                </div>

                <div class="col-span-6">
                  <label class="block text-sm font-medium text-gray-700 mb-2">أجزاء القرآن (اختياري)</label>
                  <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2">
                    <label
                      v-for="p in quranParts"
                      :key="p.id"
                      class="flex items-center gap-2 px-2 py-1 border border-gray-200 rounded-md text-sm"
                    >
                      <input type="checkbox" :value="p.id" v-model="selectedQuranParts" />
                      <span>{{ p.description || p.part_name || p.name || ('جزء ' + p.id) }}</span>
                    </label>
                  </div>
                </div>

                <div class="col-span-6 sm:col-span-3">
                  <label class="block text-sm font-medium text-gray-700">تفعيل الحساب</label>
                  <select
                    v-model="enabled"
                    class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm pr-7"
                  >
                    <option :value="true">مفعل</option>
                    <option :value="false">غير مفعل</option>
                  </select>
                </div>

                <div class="col-span-6 sm:col-span-3">
                  <label class="block text-sm font-medium text-gray-700">الحالة</label>
                  <select
                    v-model="status"
                    class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm pr-7"
                  >
                    <option value="accepted">مقبول</option>
                    <option value="pending_review">تحت المراجعة</option>
                    <option value="pending_interview">تحت المقابلة</option>
                    <option value="rejected">غير مقبول</option>
                  </select>
                </div>

                <div class="col-span-6">
                  <label class="inline-flex items-center gap-2 text-sm text-gray-700">
                    <input type="checkbox" v-model="sendEmail" />
                    إرسال بريد تأكيد (اختياري)
                  </label>
                </div>
              </div>
            </div>

            <div class="px-4 py-3 bg-gray-50 text-right sm:px-6 flex items-center gap-3 justify-end">
              <button
                type="button"
                class="inline-flex justify-center py-2 px-4 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                @click="goToStudents"
              >
                الذهاب لقائمة الدارسين
              </button>
              <button
                type="submit"
                :disabled="isSubmitting || hasValidationErrors"
                class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-customHafadhColor hover:bg-customHafadhColorHover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                :class="{ 'cursor-not-allowed opacity-70': isSubmitting || hasValidationErrors }"
              >
                {{ isSubmitting ? 'جارٍ الحفظ...' : 'حفظ' }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import url from '@/url';

export default {
  data() {
    return {
      // form
      tenantId: '',
      fullName: '',
      email: '',
      phoneCountryCode: '+966',
      phone: '',
      age: 10,
      qualificationId: '',
      durationId: '',
      masarratId: '',
      password: '',
      confirmPassword: '',
      selectedQuranParts: [],
      enabled: true,
      status: 'accepted',
      sendEmail: false,

      // lookups
      tenants: [],
      qualifications: [],
      durations: [],
      massarats: [],
      quranParts: [],

      // ui
      isSubmitting: false,
      successMessage: '',
      errorMessage: '',
      emailError: '',
      passwordError: '',
      confirmPasswordError: '',
      showPassword: false,
    };
  },
  computed: {
    userRole() {
      return localStorage.getItem('userRole') || '';
    },
    showTenantSelector() {
      // GM can create for any tenant (backend checks). Admin will create for its own tenant automatically.
      return this.userRole === 'GENERAL_MANAGER';
    },
    hasValidationErrors() {
      return !!(this.emailError || this.passwordError || this.confirmPasswordError);
    },
  },
  async mounted() {
    await this.loadLookups();
    // best-effort: prefill tenantId from token if present
    const tokenTenantId = this.extractTenantIdFromToken();
    if (tokenTenantId && !this.tenantId) {
      this.tenantId = tokenTenantId;
    }
  },
  methods: {
    extractTenantIdFromToken() {
      try {
        const token = localStorage.getItem('token');
        if (!token) return null;
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload.tenantId || payload.tenant_id || null;
      } catch (e) {
        return null;
      }
    },
    validateEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.email)) {
        this.emailError = 'الرجاء إدخال البريد الإلكتروني بشكل صحيح';
      } else {
        this.emailError = '';
      }
    },
    validatePassword() {
      const p = this.password || '';
      const lengthOk = p.length >= 8 && p.length <= 15;
      const hasSpecial = /[@#!]/.test(p);
      const hasUpper = /[A-Z]/.test(p);
      const hasLower = /[a-z]/.test(p);
      const hasDigit = /[0-9]/.test(p);

      if (!lengthOk) {
        this.passwordError = 'طول كلمة المرور يجب أن يكون بين 8 و 15';
      } else if (!(hasSpecial && hasUpper && hasLower && hasDigit)) {
        this.passwordError = 'كلمة المرور يجب أن تحتوي على حرف كبير وصغير ورقم ورمز خاص (@#!)';
      } else {
        this.passwordError = '';
      }

      if (this.confirmPassword && this.confirmPassword !== this.password) {
        this.confirmPasswordError = 'كلمتا المرور غير متطابقتين';
      } else {
        this.confirmPasswordError = '';
      }
    },
    async loadLookups() {
      const headers = { 'X-Authorization': localStorage.getItem('token') };
      const tenantId = this.extractTenantIdFromToken();

      // Tenant-scoped lookups need tenantId (public endpoints)
      let durationsUrl = url.master_durations;
      let qualificationsUrl = url.master_qualifications;
      let massaratsUrl = url.master_massarats;
      if (tenantId) {
        const tenantParam = `?tenantId=${encodeURIComponent(tenantId)}`;
        durationsUrl += tenantParam;
        qualificationsUrl += tenantParam;
        massaratsUrl += tenantParam;
      }

      const [tenantsRes, quranPartsRes, durRes, qualRes, massRes] = await Promise.all([
        axios.get(`${process.env.VUE_APP_SERVICE_URL}${url.public_tenants}`, { headers }).catch(() => null),
        axios.get(`${process.env.VUE_APP_SERVICE_URL}${url.public_quran_parts}`, { headers }).catch(() => null),
        axios.get(`${process.env.VUE_APP_SERVICE_URL}${durationsUrl}`, { headers }).catch(() => null),
        axios.get(`${process.env.VUE_APP_SERVICE_URL}${qualificationsUrl}`, { headers }).catch(() => null),
        axios.get(`${process.env.VUE_APP_SERVICE_URL}${massaratsUrl}`, { headers }).catch(() => null),
      ]);

      this.tenants = tenantsRes?.data?.result?.data || tenantsRes?.data?.data || [];
      this.quranParts = quranPartsRes?.data?.result?.data || quranPartsRes?.data?.data || [];
      this.durations = durRes?.data?.result?.data || durRes?.data?.data || [];
      this.qualifications = qualRes?.data?.result?.data || qualRes?.data?.data || [];
      this.massarats = massRes?.data?.result?.data || massRes?.data?.data || [];
    },
    goToStudents() {
      this.$router.push({ name: 'AllStudents' });
    },
    async submit() {
      this.successMessage = '';
      this.errorMessage = '';
      this.validateEmail();
      this.validatePassword();

      if (this.hasValidationErrors) return;
      if (!this.password || this.password !== this.confirmPassword) {
        this.confirmPasswordError = 'كلمتا المرور غير متطابقتين';
        return;
      }

      this.isSubmitting = true;
      try {
        const headers = { 'X-Authorization': localStorage.getItem('token') };

        const payload = {
          fullName: this.fullName,
          email: this.email,
          password: this.password,
          phone: this.phone,
          phoneCountryCode: this.phoneCountryCode,
          qualificationId: Number(this.qualificationId),
          masarratId: this.masarratId ? Number(this.masarratId) : null,
          durationId: Number(this.durationId),
          age: Number(this.age),
          quranParts: Array.isArray(this.selectedQuranParts) ? this.selectedQuranParts.map(Number) : [],
          enabled: !!this.enabled,
          status: this.status,
          sendEmail: !!this.sendEmail,
        };

        // For GENERAL_MANAGER we pass tenantId explicitly.
        if (this.showTenantSelector) {
          payload.tenantId = this.tenantId;
        }

        const res = await axios.post(
          `${process.env.VUE_APP_SERVICE_URL}${url.admin_create_student}`,
          payload,
          { headers }
        );

        const data = res?.data?.result?.data || res?.data?.data || {};
        this.successMessage = `تم إنشاء الدارس بنجاح (ID: ${data.userId || '—'})`;

        // reset sensitive fields
        this.password = '';
        this.confirmPassword = '';
        this.selectedQuranParts = [];
      } catch (e) {
        const serverMsg =
          e?.response?.data?.result?.mesAr ||
          e?.response?.data?.messageAr ||
          e?.response?.data?.message ||
          'فشل إنشاء الدارس';
        this.errorMessage = serverMsg;
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>


